import { Menu, MenuProps } from 'antd';

export type MenuAtomProps = MenuProps;

const MenuAtom = Menu;

export default MenuAtom;